import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { createColumnHelper } from '@tanstack/react-table';
import useServerFilteredTable from 'components/table/hooks/useServerFilteredTable';
import FormattedDateCell from 'components/table/cells/common/FormattedDateCell';
import { OwnerAdjustment } from 'models/ownerAdjustments/OwnerAdjustment';
import { OwnerAdjustmentsPathParams } from '../OwnerAdjustments.types';
import { oneTimeAdjustmentsQuery } from './OneTimeAdjustmentsTable.utils';
import { OneTimeAdjustmentsTableStyled } from './OneTimeAdjustmentsTable.styles';
import AmountCell from './cells/AmountCell';
import ActionsCell from './cells/ActionsCell';

const OneTimeAdjustmentsTable = () => {
  const { t } = useTranslation();
  const { propertyUid } = useParams<OwnerAdjustmentsPathParams>();
  const columnHelper = createColumnHelper<OwnerAdjustment>();
  const columns = [
    columnHelper.accessor('created', {
      header: t('pageOwnerAdjustments.columns.createdOn'),
      cell: FormattedDateCell,
    }),
    columnHelper.accessor('dateAccountedFor', {
      header: t('pageOwnerAdjustments.columns.dateAccountedFor'),
      cell: FormattedDateCell,
    }),
    columnHelper.accessor('name', {
      header: t('pageOwnerAdjustments.columns.name'),
      sortDescFirst: true,
    }),
    columnHelper.accessor('amount', {
      header: t('pageOwnerAdjustments.columns.amount'),
      cell: AmountCell,
    }),
    columnHelper.display({
      id: 'actions',
      header: t('pageOwnerAdjustments.columns.actions'),
      cell: ActionsCell,
      meta: {
        showCellTooltip: false,
      },
    }),
  ];

  const { isLoading, tableInstance } = useServerFilteredTable({
    columns,
    // @ts-expect-error TS2322 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
    getQuery: (options) => oneTimeAdjustmentsQuery({ propertyUid, ...options }),
  });

  return (
    <OneTimeAdjustmentsTableStyled
      caption={t('pageOwnerAdjustments.oneTimeAdjustments')}
      data-testid="one-time-adjustments"
      tableInstance={tableInstance}
      emptyState={t('pageOwnerAdjustments.oneTimeAdjustmentsEmptyMessage')}
      isLoading={isLoading}
    />
  );
};

export default OneTimeAdjustmentsTable;
